import { createFileRoute } from "@tanstack/react-router";

import MicrosoftIntegrationAdmin from "@/components/MicrosoftIntegrationAdmin";

// Generated to match `src/app/admin/microsoft-integration/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/microsoft-integration")({
  component: MicrosoftIntegrationAdmin,
});
